import TextSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/TextSetting';
import AccordionTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/AccordionTitle';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { VideoItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/videoItemAttributes';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

import ContentVideoUpload from './ContentVideoUpload';

const Content = (props: ComponentSettingsTab<VideoItemAttributes>) => {
  const { flagBuilderUploadVideo } = useFeatureFlag();

  return (
    <AccordionTitle isInitiallyOpen title={__('Video')}>
      {flagBuilderUploadVideo ? (
        <ContentVideoUpload {...props} />
      ) : (
        <TextSetting
          settingKey="attributes.videoUrl"
          title={__('Enter URL')}
          {...props}
        />
      )}
    </AccordionTitle>
  );
};

export default Content;
